import registerPrompt from "emun.auth/register-retailer.prompt";

export default $parse => ({
  scope: false,
  link(scope, element, attr) {


      var $targets = (attr.registerRetailerPromptSelector ? element.find(attr.registerRetailerPromptSelector) : element);
      $targets.on('click', e => {
          var model = scope.$eval(attr.registerRetailerPromptForm || attr.ngModel) || {
              language:  "en",
          };
          registerPrompt({ title: attr.title, scope, attr, element, $targets, model }).then(
              args => $parse(attr.onRegistered)(scope, args),
              args => $parse(attr.onDismissed)(scope, args)
          );
      });

    //  const ngModel = {
    //  open(e) {
    //    return registerPrompt(attr).then(
    //      args => $parse(attr.onRegistered)(scope, args),
    //      args => $parse(attr.onDismissed)(scope, args)
    //    );
    //  }
    //};

    //if (attr.ngModel) $parse(attr.ngModel).assign(scope, ngModel);

    //const $targets = attr.registerRetailerPromptSelector
    //  ? element.find(attr.registerRetailerPromptSelector)
    //  : element;
    //$targets.on("click", ngModel.open);
  }
});
